module.exports = __webpack_public_path__ + "media/images/flags/YT-523b617c5b7899bc9556b4b40cb6a82d.svg";